import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HowItWorks from "./components/HowItWorks";
import CategoryGrid from "./components/CategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import CTASection from "./components/CTASection";
import TrustSection from "./components/TrustSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <HowItWorks />
      <div id="categories">
        <CategoryGrid />
      </div>
      <ArticleGrid />
      <CTASection />
      <TrustSection />
      <Footer />
    </main>
  );
}